module.exports = __webpack_public_path__ + "img/27_93.382e6651.png";